export const CRM_NAV_ITEMS = [
  { key: "open-tasks", slug: "open-tasks", label: "Open Tasks", path: "/crm/open-tasks", module: "operations.tasks" },
  { key: "pipelines", slug: "pipelines", label: "Pipelines", path: "/crm/pipelines", module: "crm.pipelines", separator: true },
  { key: "owner", slug: "owners", label: "Owners" },
  { key: "guest", slug: "guests", label: "Guests" },
  { key: "unit", slug: "properties", label: "Properties", separator: true },
  { key: "leads", slug: "leads", label: "Leads" },
  { key: "housekeeper", slug: "housekeepers", label: "Housekeepers" },
  { key: "maintenance", slug: "maintenance", label: "Maintenance" },
  { key: "vendor", slug: "vendors", label: "Vendors" },
  { key: "other", slug: "other", label: "Other" },
];
